import { render, staticRenderFns } from "./PageViewsChartSection.vue?vue&type=template&id=3fe2d0c2&"
import script from "./PageViewsChartSection.vue?vue&type=script&lang=js&"
export * from "./PageViewsChartSection.vue?vue&type=script&lang=js&"
import style0 from "./PageViewsChartSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports